import { gql } from "@apollo/client";

export const MEDIA_TOOLKIT_QUERY = gql`
  query mediaToolkit {
    mediaToolkit {
      items {
        type
        coverImage
      }
    }
  }
`;

export const MEDIA_TOOLKIT_LINK_QUERY = gql`
  query mediaToolkitLink($type: MediaToolkitType!) {
    mediaToolkitLink(type: $type)
  }
`;
